module.exports = __webpack_public_path__ + "img/artillery-wagon-base-16.b8505616.png";